import { getDefaultExportFromCjs as e } from "./index361.js";
import { __require as r } from "./index772.js";
var o = r();
const f = /* @__PURE__ */ e(o);
export {
  f as default
};
